import {
  formatCurrency,
  FormatCurrencyOptions
} from '@vestwell-frontend/helpers';

import Decimal from 'decimal.js';
import { FC, ReactNode, useMemo } from 'react';

export type FormatCurrencyProps = Omit<
  FormatCurrencyOptions,
  'maximumFractionDigits' | 'minimumFractionDigits'
> & {
  /** decimal precision */
  precision?: number;
  prefix?: ReactNode;
  suffix?: ReactNode;
  value: string | number | Decimal;
};

export const FormatCurrency: FC<FormatCurrencyProps> = ({
  precision = 0,
  prefix,
  suffix,
  value,
  showPlaceholder = false,
  stripTrailingZeros = false,
  ...options
}) => {
  const formatted = useMemo(() => {
    const result = formatCurrency(value, {
      ...options,
      /** prevents error from INTL formatting */
      maximumFractionDigits: precision,
      minimumFractionDigits: precision,
      showPlaceholder,
      stripTrailingZeros
    });

    return (result === null || result === undefined || result === '') &&
      showPlaceholder
      ? '--'
      : result;
  }, [options, value]);

  return (
    <>
      {value !== '--' && prefix ? <>{prefix} </> : ''}
      {formatted}
      {value !== '--' && suffix ? <> {suffix}</> : ''}
    </>
  );
};

FormatCurrency.displayName = 'FormatCurrency';
